import Vue from 'vue'
import Router from 'vue-router'

const main = () => import('@/pages/inner/main')
const home = () => import('@/pages/inner/home')
const notice = () => import('@/pages/inner/notice')
const live = () => import('@/pages/inner/live')
const index = () => import('@/pages/inner/index')
const userInfo = () => import('@/pages/inner/userInfo')
const setName = () => import('@/pages/inner/setName')
const setting = () => import('@/pages/inner/setting')
const collection = () => import('@/pages/inner/collection')
const history = () => import('@/pages/inner/history')
const feedback = () => import('@/pages/inner/feedback')
const newsDetail = () => import('@/pages/inner/newsDetail')
const reset = () => import('@/pages/inner/reset')
const changePhone = () => import('@/pages/inner/changePhone')
const confirmPhone = () => import('@/pages/inner/confirmPhone')
const myComment = () => import('@/pages/inner/myComment')
const search = () => import('@/pages/inner/search')
const mySubmit = () => import('@/pages/inner/mySubmit')


const login = () => import('@/pages/outer/login')
const register = () => import('@/pages/outer/register')
const clause = () => import('@/pages/outer/clause')
const privacy = () => import('@/pages/outer/privacy')
const download = () => import('@/pages/outer/download')
const live_third = () => import('@/pages/outer/live_third')


Vue.use(Router)

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err);
}

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/home'
    }, {
      path: '/main',
      name: 'main',
      redirect: '/home',
      component: main,
      children: [{
        path: '/home',
        name: 'home',
        component: home,
      }, {
        path: '/notice',
        name: 'notice',
        component: notice,
      }, {
        path: '/live',
        name: 'live',
        component: live,
      }, {
        path: '/index',
        name: 'index',
        component: index,
      }]
    }, {
      path: '/login',
      name: 'login',
      component: login
    }, {
      path: '/register',
      name: 'register',
      component: register
    }, {
      path: '/userInfo',
      name: 'userInfo',
      component: userInfo
    }, {
      path: '/setName',
      name: 'setName',
      component: setName
    }, {
      path: '/setting',
      name: 'setting',
      component: setting
    }, {
      path: '/collection',
      name: 'collection',
      component: collection
    }, {
      path: '/history',
      name: 'history',
      component: history
    }, {
      path: '/feedback',
      name: 'feedback',
      component: feedback
    }, {
      path: '/newsDetail/:id',
      name: 'newsDetail',
      component: newsDetail
    }, {
      path: '/reset',
      name: 'reset',
      component: reset
    }, {
      path: '/changePhone',
      name: 'changePhone',
      component: changePhone
    }, {
      path: '/confirmPhone',
      name: 'confirmPhone',
      component: confirmPhone
    }, {
      path: '/myComment',
      name: 'myComment',
      component: myComment
    }, {
      path: '/search',
      name: 'search',
      component: search
    }, {
      path: '/mySubmit',
      name: 'mySubmit',
      component: mySubmit
    }, {
      path: '/clause',
      name: 'clause',
      component: clause
    }, {
      path: '/privacy',
      name: 'privacy',
      component: privacy
    }, {
      path: '/live_third',
      name: 'live_third',
      component: live_third
    }, {
      path: '/download',
      name: 'download',
      component: download
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js